import {IFilterCategoryDefinition} from "../interfaces/filter-category-definition.interface";
import {IGameFilterDefinition} from "../interfaces/game-filter-definition.interface";
import {VendorFilter} from "../filters-definitions/vendor.filter";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GameInfo} from "../../games/game-info";
import {OR} from "../evaluators/or-game-filters-evaluator";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";


export class GameVendorFiltersCategory implements IFilterCategoryDefinition {

    constructor(private readonly services: IServiceFactoryExtended) {
    }

    applyFilters(gameInfo: GameInfo, filters: IGameFilterDefinition[]): ApplyGameFilterResult {
        return OR(...filters).applyFilter(gameInfo);
    }

    readonly title: string = 'Game Vendors';

    readonly availableFilters: IGameFilterDefinition[] = [
        new VendorFilter('vendor_888','888'),
        new VendorFilter('vendor_netent', 'NetEnt'),
        new VendorFilter('vendor_playngo', 'play n go'),
        new VendorFilter('vendor_redtiger', 'Red Tiger'),
        new VendorFilter('vendor_quickspin', 'Quickspin'),
        new VendorFilter('vendor_yggdrasil', 'yggdrasil'),
        new VendorFilter('vendor_merkur', 'merkur'),
        new VendorFilter('vendor_gamomat', 'gamomat'),
        new VendorFilter('vendor_EGT', 'EGT'),
        new VendorFilter('vendor_MGA', 'MGA'),
        new VendorFilter('vendor_playtech','PlayTech'),
        new VendorFilter('vendor_pragmatic', 'Pragmatic'),
        new VendorFilter('vendor_blueprint', 'Blueprint'),
        new VendorFilter('vendor_evolution', 'Evolution'),
        new VendorFilter('vendor_light_and_wonder', 'LNW'),
        new VendorFilter('vendor_igt', 'IGT'),
        new VendorFilter('vendor_h5', 'H5'),
        new VendorFilter('vendor_everi', 'Everi')
    ];
}






